import { useState } from "react";

import { Icon } from "@/components/Icon";

interface CredentialsAlertProps {
  rows: Array<{ label: string; value: string }>;
}

export function CredentialsAlert({ rows }: CredentialsAlertProps) {
  const [copied, setCopied] = useState<string | null>(null);

  const copy = async (label: string, value: string) => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(label);
      setTimeout(() => setCopied(null), 1500);
    } catch {
      /* clipboard unavailable */
    }
  };

  return (
    <div className="credentials">
      <div className="credentials__title">
        <Icon.Key style={{ width: 16, height: 16 }} />
        Credenciales únicas — guarda ahora
      </div>
      <p
        style={{
          margin: 0,
          fontSize: 12.5,
          color: "#92400e",
          lineHeight: 1.45,
        }}
      >
        Estos valores no se vuelven a mostrar. Cópialos y guárdalos en lugar seguro.
      </p>
      <dl style={{ margin: 0, display: "grid", gap: 8 }}>
        {rows.map(({ label, value }) => (
          <div key={label} className="credentials__row">
            <dt>{label}</dt>
            <dd>{value}</dd>
            <button
              type="button"
              className="btn btn--ghost"
              style={{ padding: "4px 8px" }}
              onClick={() => copy(label, value)}
              aria-label={`Copiar ${label}`}
            >
              {copied === label ? (
                <Icon.Check style={{ color: "var(--accent-deep)" }} />
              ) : (
                <Icon.Copy />
              )}
            </button>
          </div>
        ))}
      </dl>
    </div>
  );
}
